export const SkyLayer = ({ kind, speed, rel }) => (
  <div className={`layer ${kind}`} data-speed={speed} {...(rel ? { "data-rel": "" } : {})} aria-hidden="true">
    <img src={`/assets/layer-${kind}.svg`} alt="" />
  </div>
);
